import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "grid formgrid mt-2" }
const _hoisted_2 = {
  key: 0,
  class: "col-12 mt-2 lg:col-6"
}
const _hoisted_3 = { class: "p-inputgroup" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "p-inputgroup-addon",
  style: { width: '101px' }
}, "Type", -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "p-error" }
const _hoisted_7 = {
  key: 1,
  class: "col-12 mt-2 lg:col-6"
}
const _hoisted_8 = { class: "p-inputgroup" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, "Assigned To", -1)
const _hoisted_10 = {
  key: 2,
  class: "col-12 mt-2 lg:col-6"
}
const _hoisted_11 = { class: "p-inputgroup" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", {
  class: "p-inputgroup-addon",
  style: { width: '101px' }
}, "Date", -1)
const _hoisted_13 = {
  key: 3,
  class: "grid m-2"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "billable" }, "Billable", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { for: "closed" }, "Closed", -1)
const _hoisted_16 = { class: "col-12" }
const _hoisted_17 = { class: "p-inputgroup" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", {
  class: "p-inputgroup-addon",
  style: { width: '101px' }
}, "Title", -1)
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "p-error" }
const _hoisted_21 = { class: "grid col-12 p-0 m-0 mt-2" }
const _hoisted_22 = { class: "col-12" }
const _hoisted_23 = {
  key: 0,
  class: "grid formgrid mt-2"
}
const _hoisted_24 = { class: "col-12 mt-2" }
const _hoisted_25 = { class: "mt-2" }
const _hoisted_26 = { class: "flex justify-content-end mt-2" }
const _hoisted_27 = { class: "flex gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_TextArea = _resolveComponent("TextArea")!
  const _component_AttachmentRecords = _resolveComponent("AttachmentRecords")!
  const _component_Button = _resolveComponent("Button")!
  const _component_SplitButton = _resolveComponent("SplitButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.isEditingTicket)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(_component_Dropdown, {
                options: _ctx.getBillingTypes,
                optionLabel: "billing_type",
                optionValue: "billing_type",
                modelValue: _ctx.v$.newTicket.type.$model,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.newTicket.type.$model) = $event)),
                placeholder: "Select Type",
                disabled: _ctx.editTicketField,
                class: _normalizeClass({
            'p-invalid': _ctx.submitted && _ctx.v$.newTicket.type.required.$invalid,
          })
              }, null, 8, ["options", "modelValue", "disabled", "class"])
            ]),
            (_ctx.submitted && _ctx.v$.newTicket.type.required.$invalid)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("small", _hoisted_6, _toDisplayString(_ctx.v$.newTicket.type.required.$message), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isEditingTicket)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_component_Dropdown, {
                type: "text",
                modelValue: _ctx.newTicket.assigned_to,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newTicket.assigned_to) = $event)),
                options: _ctx.getUserIDs,
                optionLabel: "user_name",
                optionValue: "user_id",
                placeholder: "Select Assignee",
                disabled: _ctx.editTicketField
              }, null, 8, ["modelValue", "options", "disabled"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isEditingTicket)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createVNode(_component_Calendar, {
                showIcon: true,
                modelValue: _ctx.ticketDate,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.ticketDate) = $event)),
                dateFormat: "mm-dd-yy",
                manualInput: false,
                disabled: true
              }, null, 8, ["modelValue"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isEditingTicket)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createVNode(_component_InputSwitch, {
              modelValue: _ctx.isTypeBillable,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isTypeBillable) = $event)),
              id: "binary",
              class: "field-checkbox mr-1",
              binary: true,
              disabled: true,
              trueValue: "Y",
              falseValue: null
            }, null, 8, ["modelValue"]),
            _hoisted_14,
            _createVNode(_component_InputSwitch, {
              modelValue: _ctx.newTicket.closed,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newTicket.closed) = $event)),
              id: "binary",
              trueValue: "Y",
              falseValue: "",
              binary: true,
              class: "field-checkbox mr-1 ml-2"
            }, null, 8, ["modelValue"]),
            _hoisted_15
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createVNode(_component_InputText, {
            type: "text",
            modelValue: _ctx.newTicket.title,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newTicket.title) = $event)),
            disabled: _ctx.editTicketField,
            class: _normalizeClass({
            'p-invalid': _ctx.submitted && _ctx.v$.newTicket.title.required.$invalid,
          })
          }, null, 8, ["modelValue", "disabled", "class"])
        ]),
        (_ctx.submitted && _ctx.v$.newTicket.title.required.$invalid)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createElementVNode("small", _hoisted_20, _toDisplayString(_ctx.v$.newTicket.title.required.$message), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_TextArea, {
            type: "text",
            rows: _ctx.isEditingTicket ? '5' : '16',
            placeholder: "Enter Description",
            modelValue: _ctx.newTicket.desc,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.newTicket.desc) = $event)),
            disabled: _ctx.editTicketField,
            class: "col-12"
          }, null, 8, ["rows", "modelValue", "disabled"])
        ])
      ])
    ]),
    (_ctx.isEditingTicket)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_TextArea, {
              type: "text",
              rows: "5",
              placeholder: "Add Comment",
              modelValue: this.newBill.desc,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((this.newBill.desc) = $event)),
              class: "col-12",
              hidden: _ctx.editTicketField ? this.newTicket.closed == 'Y' : this.newTicket.closed == 'N'
            }, null, 8, ["modelValue", "hidden"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_25, [
      _createVNode(_component_AttachmentRecords, {
        ref: "attachmentRecords",
        hostFile: "TICKET",
        record: _ctx.newTicket,
        hostId: _ctx.newTicket.id,
        onOnSaved: _ctx.handleAttachmentSaved,
        onOnDeleted: _ctx.handleAttachmentDeleted,
        onOnSaveTempAttachment: _ctx.handleSaveTempAttachment,
        showTotalAttachments: true,
        allowTempAttachments: true,
        tempAttachments: _ctx.tempTicketAttachments
      }, null, 8, ["record", "hostId", "onOnSaved", "onOnDeleted", "onOnSaveTempAttachment", "tempAttachments"])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, [
        (_ctx.showCancelButton)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              label: "Cancel",
              icon: "pi pi-times",
              onClick: _cache[8] || (_cache[8] = 
          () => {
            _ctx.isHidden = false;
            _ctx.$emit('hide', _ctx.isHidden);
          }
        ),
              class: "p-button-secondary"
            }))
          : _createCommentVNode("", true),
        (!_ctx.isEditingTicket)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              label: "Create Ticket",
              icon: "pi pi-plus",
              iconPos: "left",
              loading: _ctx.isLoadingTicket,
              onClick: _ctx.saveTicket
            }, null, 8, ["loading", "onClick"]))
          : (_ctx.isEditingTicket && _ctx.saveOptions?.length > 0)
            ? (_openBlock(), _createBlock(_component_SplitButton, {
                key: 2,
                "data-test": "saveTicket",
                label: "Save",
                icon: "pi pi-save",
                iconPos: "left",
                model: 
          _ctx.saveOptions.filter((element) => {
            return element.label;
          })
        ,
                loading: _ctx.isLoadingTicket,
                onClick: _ctx.saveTicket
              }, null, 8, ["model", "loading", "onClick"]))
            : (_ctx.isEditingTicket)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 3,
                  label: "Save",
                  icon: "pi pi-save",
                  iconPos: "left",
                  loading: _ctx.isLoadingTicket,
                  onClick: _ctx.saveTicket
                }, null, 8, ["loading", "onClick"]))
              : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}